<template>
    <button
      class="button is-outlined"
      @click="disconnectAction()"
      :disabled="false" v-translate>
      Disconnect customer
    </button>
</template>
<script>
  import { mapActions } from 'vuex'
  import { errorHandler } from '@/mixins/mixins'

  export default {
    name: 'disconnect-customer-component',
    mixins: [errorHandler],
    props: {
      item: {
        type: Object,
        required: false
      }
    },
    methods: {
      ...mapActions([
        'putDisconnectCustomer',
        'successMessage'
      ]),
      disconnectAction () {
        this.putDisconnectCustomer(this.item.customer.id).then((response) => {
          this.successMessage('Customer disconnected successfully!')
          location.reload()
        }).catch((err) => {
          this.handleError(err)
        })
      }
    }
  }
</script>
